import {combineReducers} from '@reduxjs/toolkit';

import {addAttendeesBulkSlice} from './add-attendees-bulk.slice';

export const createAddAttendeesReducer = combineReducers({
    bulkImport: addAttendeesBulkSlice.reducer,
});
